import FoodCategory from '@components/offer/models/FoodCategory';
import { Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';
import React from 'react';

interface FoodCategoryNameProps {
    foodCategory: FoodCategory;
}

const FoodCategoryName: React.FC<FoodCategoryNameProps> = observer(({ foodCategory }) => {
    return (
        <Typography
            variant='subtitle2'
            fontWeight={foodCategory.isSelected ? 600 : 500}
            ml={1.5}>
            {foodCategory.name}
        </Typography>
    )
})

export default FoodCategoryName;